<template>
  <v-card outlined>
    <v-form
      ref="form"
      data-testid="sign-up-business-account-form"
      @submit.prevent="submit"
    >
      <v-card-title>
        <h2>Business details</h2>
      </v-card-title>
      <v-card-subtitle>
        Enter your details to create a business account on AuthentiGate.
      </v-card-subtitle>
      <v-card-text>
        <v-text-field
          v-model="businessName"
          :error-messages="businessNameErrors"
          label="Business name"
          @input="$v.businessName.$touch()"
          @blur="$v.businessName.$touch()"
        />
        <v-text-field
          v-model="email"
          :error-messages="emailErrors"
          label="Email"
          type="email"
          @input="$v.email.$touch()"
          @blur="$v.email.$touch()"
        />
        <v-text-field
          v-model="firstName"
          :error-messages="firstNameErrors"
          label="First name"
          @input="$v.firstName.$touch()"
          @blur="$v.firstName.$touch()"
        />
        <v-text-field
          v-model="lastName"
          :error-messages="lastNameErrors"
          label="Last name"
          @input="$v.lastName.$touch()"
          @blur="$v.lastName.$touch()"
        />
        <v-text-field
          v-model="password"
          :error-messages="passwordErrors"
          label="Password"
          type="password"
          @input="$v.password.$touch()"
          @blur="$v.password.$touch()"
        />
        <accept-terms v-model="termsAccepted" />
      </v-card-text>
      <div class="sign-up">
        <v-btn
          x-large
          block
          color="primary"
          type="submit"
          :disabled="formInvalid"
          :loading="loading"
        >
          Sign up
        </v-btn>
      </div>
    </v-form>
  </v-card>
</template>
<script>
import SubmitUserSignUp from '@/mixins/SubmitUserSignUp'
import { validationMixin } from 'vuelidate'
import { email, minLength, required } from 'vuelidate/lib/validators'
import { STANDARD_BUSINESS } from '@/dataAccess/accountTypes'
import AcceptTerms from '@/components/AcceptTerms'

export default {
  name: 'SignUpBusinessAccount',
  components: { AcceptTerms },
  mixins: [SubmitUserSignUp, validationMixin],
  data() {
    return {
      businessName: null,
      email: null,
      firstName: null,
      lastName: null,
      password: null,
      loading: false,
      termsAccepted: false
    }
  },
  computed: {
    formInvalid() {
      return this.$v.$invalid || !this.termsAccepted
    },
    businessNameErrors() {
      const errors = []
      if (!this.$v.businessName.$dirty) return errors
      !this.$v.businessName.required && errors.push('Business name is required')
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Must be valid email')
      !this.$v.email.required && errors.push('Email is required')
      return errors
    },
    firstNameErrors() {
      const errors = []
      if (!this.$v.firstName.$dirty) return errors
      !this.$v.firstName.required && errors.push('First name is required')
      return errors
    },
    lastNameErrors() {
      const errors = []
      if (!this.$v.lastName.$dirty) return errors
      !this.$v.lastName.required && errors.push('Last name is required')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push('Password is required')
      !this.$v.password.minLength &&
        errors.push(
          `Password must have at least ${this.$v.password.$params.minLength.min} characters`
        )
      return errors
    }
  },
  validations: {
    businessName: { required },
    email: { required, email },
    firstName: { required },
    lastName: { required },
    password: { required, minLength: minLength(7) }
  },
  methods: {
    async submit() {
      this.loading = true
      await this.submitUserSignUp(STANDARD_BUSINESS.id, {
        name: `${this.firstName} ${this.lastName}`,
        businessName: this.businessName,
        email: this.email,
        password: this.password,
        termsAccepted: this.termsAccepted
      })
      this.loading = false
    }
  }
}
</script>

<style scoped></style>
